import { DataService } from '@/services/DataService'
import { arrange } from "@/libs/common.mutations";

const member = {
    namespaced: true,
    state: {
        data: [],
        dialog: null,
        memberCreateItem: null,
        memberUpdateItem: null,
        memberDeleteItem: null,
    },
    getters: {
        dataActived: (state) => {

            return state.data.filter(obj => obj.active == 1)
        }
    },
    mutations: {
        SET_DATA(state, payload) {
            arrange(state, payload)
        },
        SET_DIALOG(state) {
            state.dialog = !state.dialog
        },
        DEL_DATA(state, payload) {
            state.data = state.data.filter(obj => obj.id !== payload)
        },
        CREATE_ITEM(state, item) {
            state.memberCreateItem = item ? item : null
        },
        UPDATE_ITEM(state, item) {
            state.memberUpdateItem = item ? item : null
        },     
        DELETE_ITEM(state, item) {
            state.memberDeleteItem = item ? item : null
        }, 
    },

    actions: {

        async get({ dispatch }, id) {
            try {

                if (!id) throw ("ID not found")

                const result = await DataService.member.get(id)

                return result
            } catch (e) {

                dispatch('utils/handleHttpError', e, { root: true })
            }
        },

        async getByEmail(_, email) {
            
            const result = await DataService.member.getByEmail(email)
            return result.data
        },

        async create({ commit }, payload) {
          
            const result = await DataService.member.create(payload)
            commit('SET_DATA', result.data)
             return result;
        },


        async update({ dispatch, commit }, payload) {

         
            try {
                            
              const result  = await DataService.member.update(payload.id, payload)
                commit('SET_DATA', payload)              

                return result;
            } catch (e) {

                dispatch('utils/handleHttpError', e, { root: true })

            }
        },

        async list({ dispatch, commit }) {

            try {
                const result = await DataService.member.list();
                commit('SET_DATA', result.data)

            } catch (e) {

                dispatch('utils/handleHttpError', e, { root: true })
            }

        },

        async destroy({dispatch, commit}, id) {
            try {
                await DataService.member.destroy(id)               
                commit('DEL_DATA', id)   
                return  1           
            } catch (e) {
                dispatch('utils/handleHttpError', e, { root: true })
                return 0
            }
        },

    }
}

export { member }